// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-GroupsList__wrapper--v1JUw","item":"src-components-GroupsList__item--1LiiT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupsList.scss
// module id = 81
// module chunks = 0